import React, { useEffect } from 'react';
import * as yup from 'yup';
import {
	RadioButtonLayoutItem,
	SelectLayoutItem,
	TextFieldLayoutItem,
} from 'models/InputLayoutItem';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';
import getYearOptions from 'utils/GetYearOptions';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso4 = () => {
	const vehicleValue = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.VEHICLE_VALUE,
		sessionStorage
	);
	const vehicleYear = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.VEHICLE_YEAR,
		sessionStorage
	);
	const loanInstallmentNumber = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		//FORM.LOAN_INSTALLMENT_NUMBER,
		'loanInstallmentNumber',
		sessionStorage
	);
	const overInstallmentNumber = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.OVER_INSTALLMENT_NUMBER,
		sessionStorage
	);

	const fields: any[] = [
		{
			label: 'Valor del vehículo que quieres portar',
			defaultValue: vehicleValue ? vehicleValue : '',
			name: FORM.VEHICLE_VALUE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			placeholder: ' Ej: 9.000.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(3000000, 'Ingrese un valor superior a 3.000.000'),
		} as TextFieldLayoutItem,
		{
			defaultValue: vehicleYear ? vehicleYear : '',
			label: 'Año del vehículo',
			name: FORM.VEHICLE_YEAR,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: getYearOptions(),
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			label: 'Cuotas totales de tu crédito actual',
			defaultValue: loanInstallmentNumber ? loanInstallmentNumber : '',
			name: 'loanInstallmentNumber',
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: '36',
			mask: '##',
			validation: yup
				.number()
				.typeError('Ingrese un número válido')
				.required('Campo Requerido')
				.min(12, 'Ingrese un número válido')
				.max(60, 'Ingrese un número válido'),
		} as TextFieldLayoutItem,
		{
			defaultValue: overInstallmentNumber ? overInstallmentNumber : 'false',
			type: LAYOUT_ITEM.TYPE.RADIO_BUTTON,
			label: 'Indícanos cuál es el número de cuotas que llevas pagadas',
			name: FORM.OVER_INSTALLMENT_NUMBER,
			options: [
				{
					label: 'Entre 1 y 6 cuotas',
					value: 'false',
				},
				{
					label: 'Más de 6 cuotas',
					value: 'true',
				},
			],
		} as RadioButtonLayoutItem,
	];

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_4),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información del crédito a portar"
				body="Usaremos esta información para consultar la deuda que quieres portar"
			/>

			<CreateFormLayout key={fields.length} fields={fields} />
		</div>
	);
};
